/* Extracted from snippets/cart-drawer.liquid so it ships as a cached asset instead of inline JS. */
(function () {
    if (window.__cartDrawerBackdropInit) return;
    window.__cartDrawerBackdropInit = true;
    function drawer() { return document.getElementById('CartDrawer'); }
    function backdrop() { return document.getElementById('CartDrawerBackdrop'); }
    function isOpen() { var d = drawer(); return d && !d.classList.contains('translate-x-full'); }
    function sync() { var b = backdrop(); if (b) b.classList.toggle('is-open', isOpen()); }
    function close() { var d = drawer(); if (!d) return; d.classList.add('translate-x-full'); d.setAttribute('aria-hidden', 'true'); sync(); }
    document.addEventListener('click', function (ev) { if (ev.target && ev.target.id === 'CartDrawerBackdrop') close(); });

    /* Discount codes go onto the cart itself via /cart/update.js { discount }, so the drawer
       re-renders with the real outcome: struck prices, a row per discount, the new total. The
       field takes the full comma-separated list, so applying adds to the codes already there
       and removing sends back the rest. A code that comes back applicable: false is taken
       straight off again and explained, rather than left sitting on the cart doing nothing. */
    function currentCodes() {
      return Array.prototype.map.call(document.querySelectorAll('[data-discount-code]'), function (el) {
        return el.getAttribute('data-discount-code');
      });
    }
    function showError(msg) {
      var el = document.querySelector('[data-discount-error]');
      if (!el) return;
      el.textContent = msg || '';
      el.hidden = !msg;
    }
    function setCodes(codes) {
      return fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ discount: codes.join(',') })
      }).then(function (r) { return r.json(); });
    }
    function refresh() {
      var p = window.refreshCartDrawerContent ? window.refreshCartDrawerContent() : Promise.resolve();
      return Promise.resolve(p).then(function () { window.dispatchEvent(new CustomEvent('cart:updated')); });
    }
    function applyCode(code, btn) {
      code = String(code || '').trim();
      if (!code) return;
      var existing = currentCodes();
      if (existing.some(function (c) { return c.toLowerCase() === code.toLowerCase(); })) {
        showError('Code ' + code.toUpperCase() + ' is already applied.');
        return;
      }
      if (btn) { btn.disabled = true; btn.textContent = 'Applying…'; }
      var rejected = false;
      setCodes(existing.concat(code)).then(function (cart) {
        var hit = (cart && cart.discount_codes || []).filter(function (d) {
          return String(d.code).toLowerCase() === code.toLowerCase();
        })[0];
        if (!hit || !hit.applicable) {
          rejected = true;
          return setCodes(existing);
        }
      }).catch(function () { rejected = true; }).then(refresh).then(function () {
        // the drawer just re-rendered, so look the error element up again
        showError(rejected ? 'Code ' + code.toUpperCase() + ' isn\u2019t valid for the items in your bag.' : '');
        if (btn) { btn.disabled = false; btn.textContent = 'Apply'; }
      });
    }
    function removeCode(code) {
      var rest = currentCodes().filter(function (c) { return c !== code; });
      showError('');
      setCodes(rest).catch(function () {}).then(refresh);
    }

    document.addEventListener('click', function (ev) {
      var apply = ev.target.closest ? ev.target.closest('[data-discount-apply]') : null;
      if (apply) {
        var input = document.querySelector('[data-discount-input]');
        applyCode(input && input.value, apply);
        return;
      }
      var remove = ev.target.closest ? ev.target.closest('[data-discount-remove]') : null;
      if (remove) removeCode(remove.getAttribute('data-discount-remove'));
    });

    document.addEventListener('keydown', function (ev) {
      if (ev.key !== 'Enter') return;
      var t = ev.target;
      if (t && t.matches && t.matches('[data-discount-input]')) {
        ev.preventDefault();
        applyCode(t.value, document.querySelector('[data-discount-apply]'));
      }
    });
    document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape' && isOpen()) close(); });
    var d = drawer();
    if (d) { new MutationObserver(sync).observe(d, { attributes: true, attributeFilter: ['class'] }); }
    sync();
  })();
